import axios from '@/services/servicio-base';

const servicioNotificacion = {}

servicioNotificacion.obtenerNotificacion = function(){
    return axios.get('/Notificaciones/ultimasNotificaciones')    
    .then(r=>{                                
        return r;
    })
    .catch(e=>{
        return e;
    });    
}

servicioNotificacion.marcarNotificacionRedirigida = function(todasRedirigidas,codigoNotificacion){
    return axios.post('Notificaciones/redireccionadas',{todasRedirigidas,codigoNotificacion})
    .then(r=>{
            return r.data;
        }).catch(e=>{
            return e ;
    });
}

servicioNotificacion.marcarNotificacionesVista = function(){
    return axios.post('Notificaciones/marcarVistas')
    .then(r=>{  
        return r.data;
    }).catch(e=>{
        return e;
    })
}

export default servicioNotificacion;